import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCompetitions } from '../services/public-api';
import Loading from '../components/common/Loading';
import Container from '../components/layout/Container';

/**
 * RedirectToActiveCompetition
 * Redirects to the first active competition's fixtures or standings page.
 * Useful for top-level nav links like /fixtures and /results.
 */
export function RedirectToCompFixtures() {
  return <RedirectToActive suffix="fixtures" />;
}

export function RedirectToCompResults() {
  return <RedirectToActive suffix="fixtures" extraQuery="?view=results" />;
}

function RedirectToActive({ suffix, extraQuery = '' }) {
  const navigate = useNavigate();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    getCompetitions()
      .then(data => {
        const comps = data.competitions || [];
        const active = comps.find(c => c.status === 'active') || comps[0];
        if (active) {
          navigate(`/competitions/${active.competitionId}/${suffix}${extraQuery}`, { replace: true });
        } else {
          setNotFound(true);
        }
      })
      .catch(() => setNotFound(true));
  }, []);

  if (notFound) return (
    <Container>
      <p style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>
        No active competitions found.
      </p>
    </Container>
  );

  return <Container><Loading /></Container>;
}
